import React, { Component } from 'react';
import { Text, View, Image, ScrollView, Dimensions, Platform } from 'react-native';
import { postSingle, Flex, Padding, Margin, Helpers, newsletter, FontFamily, Colors,Typo ,featuredArticle,button} from '../../styles/appStyles';
import TouchableOpacityLink from '../touchable-opacity-link';
import TouchableOpacityLinkExternal from '../touchable-opacity-link-external';
import CustomImage from '../custom-image';
import getImagePath from '../../utils/image-helper';
import { helpers } from '../../utils/helpers';
import ButtonGradient from '../button-gradient';
import ButtonGradientView from '../button-gradient/index-view.js';
import moment from 'moment';
import apiHelpers from "../../utils/api-helpers";
const appLogo = getImagePath('icons/tmc-logo.png');
const newsletterImg = getImagePath('img/things-change.png');
const arrowRight = getImagePath('icons/arrow-right-orange.png');

export class PastNewsletterListing extends Component {
    constructor(props) {
        super(props);
        this.state = {
featuredWriter:false,
        }
    }

    componentDidMount = () => {
         let { token } = this.props;
        let endpoint = `/newsletter/${this.props.newsLetter.name.replace(/\s+/g, '-').toLowerCase()}`;
        let body = {
          
        };

       
        apiHelpers
            .apiRequest(endpoint, body, "GET", true, token)
            .then((res) => {
                if (res.success) {
                  this.setState({featuredWriter:res.data.featured_writer},()=>{

                      console.log(this.state.featuredWriter);
                  });
                  console.log('here',res,'ashish');
                }
                else {
                
                console.log('here');
                }
            })
            .catch((error) => {
                
                console.log('Error=>> down', JSON.stringify(error));
            });
    }
  navigateTo = (screen) => {
        if (helpers.isWeb()) {
            this.props.navigateToScreen(screen)
        }
        else {
            this.props.navigation.navigate('/pricing');
        }
    }

    render() {
        let { newsLetter, darkMode } = this.props;
        let webView = helpers.isWeb();
        let viewBtnProps,authorBtnClick;
        if (webView) {
            viewBtnProps = {
                to: "/newsletters/" + newsLetter.slug
            }
            
            authorBtnClick = {
                to: "/writers/" + this.state.featuredWriter.slug
            }
            
        } else {
            viewBtnProps = {
                onPress: () => this.props.getNewsletterClick(newsLetter.slug)
            }
        }
        return (
            <>
              {helpers.isDesktop() && <TouchableOpacityLink {...viewBtnProps} > <View >     
         
              <View style={[helpers.isDesktop() && Flex.column,    !helpers.isDesktop() && Margin.mb_3,  !helpers.isWeb() && newsletter.appWrapper, darkMode && { backgroundColor: Colors.darkBlackColor, shadowColor: "rgba(0, 0, 0, 0.80)" }]}>     
            <View style={[helpers.isDesktop() && Flex.row, helpers.isDesktop() && Flex.alignCenter, helpers.isDesktop() && Margin.mb_2,  !helpers.isDesktop() && Margin.mb_3,  !helpers.isWeb() && newsletter.appWrapper, darkMode && { backgroundColor: Colors.darkBlackColor, shadowColor: "rgba(0, 0, 0, 0.80)" }]}>
                <View style={[!helpers.isDesktop() && { margin: 'auto' }, helpers.isDesktop() && {  margin: 'auto', alignItems: 'center' }, !helpers.isWeb() && { alignItems: 'center' }]}>
                   
                        <CustomImage
                            source={newsLetter.logo}
                            require={false}
                            style={{ width: 250, height: 130, resizeMode: 'contain', margin: 'auto' }}
                            webStyle={{  height: helpers.isDesktop() ? 'auto' : 'auto', objectFit: 'contain', margin: 'auto' }}
                            altText={newsLetter.name}
                        />
                        {
                            darkMode &&
                            <View style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(18, 18, 18, 0.05)' }}>

                            </View>
                        }
                          {
                           
                   ( this.props.newsLetter.name.replace(/\s+/g, '-').toLowerCase()=='friction'||this.props.newsLetter.name.replace(/\s+/g, '-').toLowerCase()=='one-less-thing-to-worry-about'||this.props.newsLetter.name.replace(/\s+/g, '-').toLowerCase()=='oversize'||this.props.newsLetter.name.replace(/\s+/g, '-').toLowerCase()=='things-change')  &&     <View style={{ position: 'absolute', top: helpers.isDesktop()? 10:50,  right: 0, width:'40%',height:20, backgroundColor: '#0077C8' }}>
<Text style={{fontFamily: FontFamily.abrilFatface,color:'#ffffff',textAlign:'center',letterSpacing:1}}>Premium</Text>
                            </View>
                        }
                  
                </View>
                <View style={[{ flex: 1 }, helpers.isDesktop() && { paddingLeft: 15 ,alignSelf:'baseline'}, !helpers.isDesktop() && { marginTop: 20 }]}>
                    <View style={[ !helpers.isDesktop() && Padding.pb_2]}>
                     {/* <Text style={[featuredArticle.newslettermain, helpers.isDesktop() &&  featuredArticle.titleDesktop,  {fontFamily: FontFamily.medium, letterSpacing: 0.3, fontWeight: '600', fontSize: 20, lineHeight: 42 },  {textAlign:'left', lineHeight: 35}, (!helpers.isWeb() ) && {fontFamily: FontFamily.bold}, darkMode && {color: 'rgba(255,255,255,0.87)'}]}>{newsLetter.name}</Text>
                   */}
                     <Text style={[featuredArticle.newslettertitle, helpers.isDesktop() &&  featuredArticle.titleDesktop,  {textAlign:'left', lineHeight: 35},  darkMode && {color: 'rgba(255,255,255,0.87)'},{ fontFamily: FontFamily.abrilFatface },  { fontSize: helpers.isDesktop() ? 25 : 20, lineHeight: helpers.isDesktop() ? 30 : 22, color: '#000' }, darkMode && { color: 'rgba(255,255,255,0.87)' }]}>{newsLetter.name}</Text>
                              
                        {/* <Text style={[newsletter.title, !helpers.isDesktop() && { paddingBottom: 10, fontSize: 16 }, helpers.isDesktop() && { fontSize: 18, lineHeight: 30 }, darkMode && { color: Colors.lightWhite }]}>{newsLetter.description}</Text> */}
                        <View style={[newsletter.lineBreak, Margin.mt_0, Margin.mb_1, helpers.isDesktop() && [Margin.mb_2, Margin.mt_1]]}></View>
                         </View>
                    {/* {helpers.isWeb() ?
                        <TouchableOpacityLink {...viewBtnProps}>
                            <Text style={[newsletter.linkText]}>View this newsletter</Text>
                            <CustomImage
                                source={arrowRight}
                                require={true}
                                style={{ width: 25, height: 15, resizeMode: 'cover', marginLeft: 9 }}
                                webStyle={{ width: 17, height: 'auto', objectFit: 'cover', marginLeft: 9 }}
                            />
                        </TouchableOpacityLink>
                        :
                        <TouchableOpacityLink {...viewBtnProps}>
                            <View style={[Flex.row, Flex.alignCenter]}>
                                <Text style={[newsletter.linkText]}>View this newsletter</Text>
                                <CustomImage
                                    source={arrowRight}
                                    require={true}
                                    style={{ width: 20, height: 10, resizeMode: 'cover', marginLeft: 9 }}
                                    webStyle={{ width: 17, height: 'auto', objectFit: 'cover', marginLeft: 9 }}
                                />
                            </View>
                        </TouchableOpacityLink>
                    } */}
                     <View>
                                <View style={[postSingle.authorDetailsnewsWrap,Flex.column, helpers.isDesktop() && Flex.justfiyCenter, helpers.isDesktop() && Flex.justifyStart, Flex.FlexWrap,{alignSelf:'flex-start'}]}>
                                  {this.state.featuredWriter&& <TouchableOpacityLink
                                       {...authorBtnClick}>
                                     {this.state.featuredWriter&&<View style={[postSingle.authorDetailsWrap, helpers.isDesktop() && Flex.alignCenter, Flex.justfiyCenter, helpers.isDesktop() && Flex.justifyStart,helpers.isDesktop()&&{marginBottom:'10px'}]}>
                                            <View style={[postSingle.authorPicWrap, { width: 25, height: 25 }]}>
                                                <CustomImage
                                                    source={this.state.featuredWriter.profile_image}
                                                    require={false}
                                                    webStyle={{
                                                        width: 25,
                                                        height: 25,
                                                        borderRadius: 100,
                                                    }}
                                                    resizeMode={'contain'}
                                                    style={{width: 25, height: 25, borderRadius: 100}}
                                                    altText={'name'}
                                                />
                                            </View> 
                                            <View style={[Padding.pl_1]}> 
                                                <Text style={[postSingle.authorName, helpers.isDesktop() && postSingle.authorNameDesktop, ( !helpers.isDesktop()) && {fontSize: 15},( helpers.isDesktop()) && {fontWeight: '400'}, darkMode && {color: 'rgba(255,255,255,0.87)'}]}>{this.state.featuredWriter.name}</Text>
                                            </View>
                                        </View>
                                     }  
                                     {!this.state.featuredWriter&&<View style={[postSingle.authorDetailsWrap, helpers.isDesktop() && Flex.alignCenter, Flex.justfiyCenter, helpers.isDesktop() && Flex.justifyStart,!helpers.isDesktop()&&{marginBottom:'10px'}]}>
                                            <View style={[postSingle.authorPicWrap, { width: 25, height: 25 }]}>
                                                <CustomImage
                                                    source={appLogo}
                                                    require={false}
                                                    webStyle={{
                                                        width: 25,
                                                        height: 25,
                                                        borderRadius: 100,
                                                    }}
                                                    resizeMode={'contain'}
                                                    style={{width: 25, height: 25, borderRadius: 100}}
                                                    altText={'name'}
                                                />
                                            </View> 
                                            <View style={[Padding.pl_1]}> 
                                                <Text style={[postSingle.authorName, helpers.isDesktop() && postSingle.authorNameDesktop, ( !helpers.isDesktop()) && {fontSize: 15},( helpers.isDesktop()) && {fontWeight: '400'}, darkMode && {color: 'rgba(255,255,255,0.87)'}]}>{'Team TMC'}</Text>
                                            </View>
                                        </View>
                                     }   
                                    </TouchableOpacityLink>}
                                    { !this.state.featuredWriter&&<TouchableOpacityLink
                                      >
                                     {this.state.featuredWriter&&<View style={[postSingle.authorDetailsWrap, helpers.isDesktop() && Flex.alignCenter, Flex.justfiyCenter, helpers.isDesktop() && Flex.justifyStart,helpers.isDesktop()&&{marginBottom:'10px'}]}>
                                            <View style={[postSingle.authorPicWrap, { width: 25, height: 25 }]}>
                                                <CustomImage
                                                    source={this.state.featuredWriter.profile_image}
                                                    require={false}
                                                    webStyle={{
                                                        width: 25,
                                                        height: 25,
                                                        borderRadius: 100,
                                                    }}
                                                    resizeMode={'contain'}
                                                    style={{width: 25, height: 25, borderRadius: 100}}
                                                    altText={'name'}
                                                />
                                            </View> 
                                            <View style={[Padding.pl_1]}> 
                                                <Text style={[postSingle.authorName, helpers.isDesktop() && postSingle.authorNameDesktop, ( !helpers.isDesktop()) && {fontSize: 15},( helpers.isDesktop()) && {fontWeight: '400'}, darkMode && {color: 'rgba(255,255,255,0.87)'}]}>{this.state.featuredWriter.name}</Text>
                                            </View>
                                        </View>
                                     }  
                                     {!this.state.featuredWriter&&<View style={[postSingle.authorDetailsWrap, helpers.isDesktop() && Flex.alignCenter, Flex.justfiyCenter, helpers.isDesktop() && Flex.justifyStart,!helpers.isDesktop()&&{marginBottom:'10px'}]}>
                                            <View style={[postSingle.authorPicWrap, { width: 25, height: 25 }]}>
                                                <CustomImage
                                                    source={appLogo}
                                                    require={false}
                                                    webStyle={{
                                                        width: 25,
                                                        height: 25,
                                                        borderRadius: 100,
                                                    }}
                                                    resizeMode={'contain'}
                                                    style={{width: 25, height: 25, borderRadius: 100}}
                                                    altText={'name'}
                                                />
                                            </View> 
                                            <View style={[Padding.pl_1]}> 
                                                <Text style={[postSingle.authorName, helpers.isDesktop() && postSingle.authorNameDesktop, ( !helpers.isDesktop()) && {fontSize: 15},( helpers.isDesktop()) && {fontWeight: '400'}, darkMode && {color: 'rgba(255,255,255,0.87)'}]}>{'Team TMC'}</Text>
                                            </View>
                                        </View>
                                     }   
                                    </TouchableOpacityLink>}
                                    { <>
                                        {/* <View style={[featuredArticle.dotSeprator,{marginBottom: 0}]} /> */}
                                        <TouchableOpacityLink
                                         >
                                        <View style={[postSingle.authorDetailsWrap, Flex.alignCenter, Flex.justfiyCenter, helpers.isDesktop() && Flex.justifyStart]}>
                                            <View style={[ { width: 25, height: 25,marginTop:5 }]}>
                                                <CustomImage
                                                    source={'https://user-images.githubusercontent.com/62637513/130725363-0568a05b-784f-48b1-ae89-e4f10c0c143c.png'}
                                                    require={false}
                                                    webStyle={{
                                                        width: 25,
                                                        height: 25,
                                                       
                                                    }}
                                                    resizeMode={'contain'}
                                                    style={{width: 25, height: 25, borderRadius: 100}}
                                                    altText={'name'}
                                                />
                                            </View>
                                            <View style={[Padding.pl_1]}>
                                                <Text style={[postSingle.authorName, helpers.isDesktop() && postSingle.authorNameDesktop, ( !helpers.isDesktop()) && {fontSize: 15},( helpers.isDesktop()) && {fontWeight: '400'},darkMode && {color: 'rgba(255,255,255,0.87)'}]}>{`${newsLetter.available}`}</Text>
                                            </View>
                                        </View>
                                    </TouchableOpacityLink></>}
                                        {/* { ( helpers.isDesktop()) && <View style={[featuredArticle.dotSeprator, {marginTop: 0}]} />} */}
                                         </View>
                            </View>
                </View>



            </View>


  <Text style={[newsletter.title, !helpers.isDesktop() && { paddingBottom: 10, fontSize: 16 }, helpers.isDesktop() && { fontSize: 18, lineHeight: 30,width:'90%' }, darkMode && { color: Colors.lightWhite }]}>{newsLetter.description}</Text>
           <View style={[helpers.isDesktop() && Flex.row, helpers.isDesktop() && Flex.alignCenter, helpers.isDesktop() && Margin.mb_2,  !helpers.isDesktop() && Margin.mb_3, , !helpers.isWeb() && newsletter.appWrapper, darkMode && { backgroundColor: Colors.darkBlackColor, shadowColor: "rgba(0, 0, 0, 0.80)" }]}>
            <View style={{width:'192px'}}> <View style={[Margin.mt_15]}>
             {/* <TouchableOpacityLink {...viewBtnProps} > */}
                                        <ButtonGradientView
                                            title={'VIEW'}
                                            //  onClick={() =>  this.props.navigation.navigate('/pricing')}
                                            rootStyle={{
                                                btnWrapper: button.primaryGradientView,
                                                btnText: button.primaryGradientTextView,
                                            }}
                                            // loader={btnLoader}
                                            // disable={btnDisable}
                                        />
                                         {/* </TouchableOpacityLink  > */}
                                    </View></View>
             <View style={{width:'50%'}} >
             
             
             
             
             </View>
           </View>
           
            </View>
             </View>  </TouchableOpacityLink>}
               {!helpers.isDesktop() &&  <TouchableOpacityLink {...viewBtnProps} > <View style={[helpers.isDesktop() && Flex.column,  helpers.isDesktop() && Margin.mb_9,  !helpers.isDesktop() && { paddingHorizontal: '5%' },  !helpers.isWeb() && newsletter.appWrapper, darkMode && { backgroundColor: Colors.darkBlackColor, shadowColor: "rgba(0, 0, 0, 0.80)" }]}>     
            <View style={[{ flex: 1 }, helpers.isDesktop() && { paddingLeft: 15 ,alignSelf:'baseline'}, !helpers.isDesktop() && { marginTop: 10 }]}>
                    <View style={[ !helpers.isDesktop() && Padding.pb_2]}>
                     {/* <Text style={[featuredArticle.newslettermain, helpers.isDesktop() &&  featuredArticle.titleDesktop,  {fontFamily: FontFamily.medium, letterSpacing: 0.3, fontWeight: '600', fontSize: 20, lineHeight: 42 },  {textAlign:'left', lineHeight: 35}, (!helpers.isWeb() ) && {fontFamily: FontFamily.bold}, darkMode && {color: 'rgba(255,255,255,0.87)'}]}>{newsLetter.name}</Text>
                   */}
                    
                              
                        {/* <Text style={[newsletter.title, !helpers.isDesktop() && { paddingBottom: 10, fontSize: 16 }, helpers.isDesktop() && { fontSize: 18, lineHeight: 30 }, darkMode && { color: Colors.lightWhite }]}>{newsLetter.description}</Text> */}
                        {/* <View style={[newsletter.lineBreak, Margin.mt_0, Margin.mb_1, !helpers.isDesktop() && {margin:'auto'}]}></View> */}
                         </View>
            <View style={[!helpers.isDesktop() && Flex.row, helpers.isDesktop() && Flex.alignCenter, helpers.isDesktop() && Margin.mb_2,  !helpers.isDesktop() && Margin.mb_3, { paddingHorizontal: 20,alignItems:'center' }, , !helpers.isWeb() && newsletter.appWrapper, darkMode && { backgroundColor: Colors.darkBlackColor, shadowColor: "rgba(0, 0, 0, 0.80)" }]}>
               
                <View style={[ !helpers.isDesktop() && { width: '50%',alignItems: 'center',display:'unset'  }, !helpers.isWeb() && { alignItems: 'center' }]}>
                  
                        <CustomImage
                            source={newsLetter.logo}
                            require={false}
                            style={{ width: '100%',height:'100%' }}
                            webStyle={{ width: '100px',height:'100px' }}
                            altText={newsLetter.name}
                        />
                        {
                            darkMode &&
                            <View style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(18, 18, 18, 0.05)' }}>

                            </View>
                        }
                      {
                           
                   ( this.props.newsLetter.name.replace(/\s+/g, '-').toLowerCase()=='friction'||this.props.newsLetter.name.replace(/\s+/g, '-').toLowerCase()=='one-less-thing-to-worry-about'||this.props.newsLetter.name.replace(/\s+/g, '-').toLowerCase()=='oversize'||this.props.newsLetter.name.replace(/\s+/g, '-').toLowerCase()=='things-change')  &&     <View style={{ position: 'absolute', top: helpers.isDesktop()? 10:10,  right: 30, width:'40%',height:20, backgroundColor: '#0077C8' }}>
<Text style={{fontFamily: FontFamily.abrilFatface,color:'#ffffff',textAlign:'center',letterSpacing:1,fontSize:'12px'}}>Premium</Text>
                            </View>
                        }
                 
                </View>
               
                 
                     <View>
                               
                                <View style={[postSingle.authorDetailsnewsWrap,Flex.column, helpers.isDesktop() && Flex.justfiyCenter, helpers.isDesktop() && Flex.justifyStart, Flex.FlexWrap,{alignSelf:'baseline',marginLeft:helpers.isDesktop()?0:0}]}>
                                    <Text style={[featuredArticle.newslettertitle, helpers.isDesktop() &&  featuredArticle.titleDesktop,  {textAlign:'left', lineHeight: 35},  darkMode && {color: 'rgba(255,255,255,0.87)'},{ fontFamily: FontFamily.abrilFatface },  { fontSize: helpers.isDesktop() ? 25 :newsLetter.name.length>10? 12:20, lineHeight: helpers.isDesktop() ? 30 : 22, color: '#000' }, darkMode && { color: 'rgba(255,255,255,0.87)' }]}>{newsLetter.name}</Text>
                                   
                                    { <TouchableOpacityLink
                                    style={{alignSelf:'baseline'}}
                                       >
                                      { this.state.featuredWriter&&
                                        <View style={[postSingle.authorDetailsWrap, helpers.isDesktop() && Flex.alignCenter, Flex.justfiyCenter, helpers.isDesktop() && Flex.justifyStart,helpers.isDesktop()&&{marginBottom:'10px'}]}>
                                            <View style={[postSingle.authorPicWrap, { width: 20, height: 20 }]}>
                                                <CustomImage
                                                    source={this.state.featuredWriter.profile_image}
                                                    require={false}
                                                    webStyle={{
                                                        width: 20,
                                                        height: 20,
                                                        borderRadius: 100,
                                                    }}
                                                    resizeMode={'contain'}
                                                    style={{width: 20, height: 20, borderRadius: 100}}
                                                    altText={'name'}
                                                />
                                            </View> 
                                            <View style={[Padding.pl_1]}> 
                                                <Text style={[postSingle.authorName, helpers.isDesktop() && postSingle.authorNameDesktop, ( !helpers.isDesktop()) && {fontSize: 16},( helpers.isDesktop()) && {fontWeight: '400'}, darkMode && {color: 'rgba(255,255,255,0.87)'}]}>{this.state.featuredWriter.name}</Text>
                                            </View>
                                        </View>}
                                         { !this.state.featuredWriter&&
                                        <View style={[postSingle.authorDetailsWrap, helpers.isDesktop() && Flex.alignCenter, Flex.justfiyCenter, helpers.isDesktop() && Flex.justifyStart,!helpers.isDesktop()&&{marginBottom:'10px'}]}>
                                            <View style={[postSingle.authorPicWrap, { width: 20, height: 20 }]}>
                                                <CustomImage
                                                    source={appLogo}
                                                    require={false}
                                                    webStyle={{
                                                        width: 20,
                                                        height: 20,
                                                        borderRadius: 100,
                                                    }}
                                                    resizeMode={'contain'}
                                                    style={{width: 20, height: 20, borderRadius: 100}}
                                                    altText={'name'}
                                                />
                                            </View> 
                                            <View style={[Padding.pl_1]}> 
                                                <Text style={[postSingle.authorName, helpers.isDesktop() && postSingle.authorNameDesktop, ( !helpers.isDesktop()) && {fontSize: 16},( helpers.isDesktop()) && {fontWeight: '400'}, darkMode && {color: 'rgba(255,255,255,0.87)'}]}>{'Team TMC'}</Text>
                                            </View>
                                        </View>}
                                    </TouchableOpacityLink>}
                                    { <>
                                        {/* <View style={[featuredArticle.dotSeprator,{marginBottom: 0}]} /> */}
                                        <TouchableOpacityLink
                                         >
                                        <View style={[postSingle.authorDetailsWrap, Flex.alignCenter, helpers.isDesktop() && Flex.justifyStart]}>
                                            <View style={[ { width: 20, height: 20,marginTop:5 }]}>
                                                <CustomImage
                                                    source={'https://user-images.githubusercontent.com/62637513/130725363-0568a05b-784f-48b1-ae89-e4f10c0c143c.png'}
                                                    require={false}
                                                    webStyle={{
                                                        width: 20,
                                                        height: 20,
                                                       
                                                    }}
                                                    resizeMode={'contain'}
                                                    style={{width: 15, height: 15, borderRadius: 100}}
                                                    altText={'name'}
                                                />
                                            </View>
                                            <View style={[Padding.pl_1]}>
                                                <Text style={[postSingle.authorName, helpers.isDesktop() && postSingle.authorNameDesktop, ( !helpers.isDesktop()) && {fontSize: 16,fontWeight:500},( helpers.isDesktop()) && {fontWeight: '400'},darkMode && {color: 'rgba(255,255,255,0.87)'}]}>{`${newsLetter.available}`}</Text>
                                            </View>
                                        </View>
                                    </TouchableOpacityLink></>}
                                        {/* { ( helpers.isDesktop()) && <View style={[featuredArticle.dotSeprator, {marginTop: 0}]} />} */}
                                         </View>
                            </View>
                </View>



            </View>


  <Text style={[newsletter.title, !helpers.isDesktop() && { paddingBottom: 10, fontSize: 16 }, helpers.isDesktop() && { fontSize: 18, lineHeight: 30 }, darkMode && { color: Colors.lightWhite }]}>{newsLetter.description}</Text>
           <View style={[helpers.isDesktop() && Flex.row, helpers.isDesktop() && Flex.alignCenter, helpers.isDesktop() && Margin.mb_2,  !helpers.isDesktop() && Margin.mb_3, , !helpers.isWeb() && newsletter.appWrapper, darkMode && { backgroundColor: Colors.darkBlackColor, shadowColor: "rgba(0, 0, 0, 0.80)" }]}>
            <View style={[ {width:'60%'}]}> <View style={[Margin.mt_15]}>
           {this.props.token? <TouchableOpacityLink {...viewBtnProps} >
                                        <ButtonGradientView
                                       
                                            title={'View'}
                                            // onClick={() =>  this.props.navigation.navigate('/pricing')}
                                            rootStyle={{
                                                btnWrapper: button.primaryGradientView,
                                                btnText: button.primaryGradientTextView,
                                            }}
                                            // loader={btnLoader}
                                            // disable={btnDisable}
                                        />
                                         </TouchableOpacityLink >:null} 
                                    </View></View>
        {  helpers.isDesktop() &&    <View style={{width:'50%'}} >
             
             
             
             
             </View>}
              <View style={[ { width: 20, height: 20,marginTop:5 }]}>
                                                <CustomImage
                                                    source={'https://user-images.githubusercontent.com/62637513/132447060-3503cabb-4683-41e1-b90f-f5eadf853039.png'}
                                                    require={false}
                                                    webStyle={{
                                                        width: 20,
                                                        height: 10,
                                                       
                                                    }}
                                                    resizeMode={'contain'}
                                                    style={{width: 15, height: 10, borderRadius: 100}}
                                                    altText={'name'}
                                                />
                                            </View>
           </View>
           
            </View> </TouchableOpacityLink>}
            </>
        );
    }
}

export default PastNewsletterListing;